
<main id="main-content">
    <router-outlet></router-outlet>
    <app-loader></app-loader>
</main>
 